import { Button } from "@sellar-io/components";
import { ReactElement } from "react";

import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";

import { useAddOrderToSellarDistributionPallet } from "./hooks/useAddOrderToSellarDistributionPallet";
import { Alert } from "../../../../components/alert/Alert";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";

export function AdminAddOrderToPallet({
  active,
  orderId,
  onDismiss,
}: {
  active: boolean;
  orderId: number;
  onDismiss: () => void;
}): ReactElement {
  const addOrderToSupplierPalletShipmentMutation =
    useAddOrderToSellarDistributionPallet(orderId);

  const onConfirm = () => {
    addOrderToSupplierPalletShipmentMutation.mutate(undefined, {
      onSuccess: () => {
        onDismiss();
      },
    });
  };

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title="Add order to latest pallet"
      />
      <DialogContent>
        {addOrderToSupplierPalletShipmentMutation.isError && (
          <Alert
            type={"error"}
            message={
              apiV2AssertError(addOrderToSupplierPalletShipmentMutation.error)
                ?.response?.data.message ?? "An unknown error occurred"
            }
          />
        )}

        <div>
          Please confirm you wish to add the order to the next available pallet
        </div>
      </DialogContent>
      <DialogCTA>
        <Button onClick={onConfirm}>Confirm</Button>
      </DialogCTA>
    </Dialog>
  );
}
